export type ContentOrientation = "day" | "night" | "ism";

const OPTIONS: Array<{ value: ContentOrientation; label: string }> = [
  { value: "day", label: "Day" },
  { value: "night", label: "Night" },
  { value: "ism", label: "ISM" },
];

type Props = {
  value: ContentOrientation;
  onChange: (value: ContentOrientation) => void;
  className?: string;
};

export function ContentOrientationToggle({ value, onChange, className = "" }: Props) {
  return (
    <div
      className={`inline-flex items-center rounded-xl border border-border bg-black/30 p-1 ${className}`}
      role="group"
      aria-label="Content orientation"
    >
      {OPTIONS.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          aria-pressed={value === option.value}
          className={`min-w-16 rounded-lg px-3 py-1.5 text-xs font-semibold uppercase tracking-wider transition-colors ${
            value === option.value
              ? "bg-primary text-white shadow-sm"
              : "text-muted-foreground hover:bg-white/5 hover:text-foreground"
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}